/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Platform, UserService } from '../services/user.service';
import { MiddlewareBrowseComponent } from './middleware-browse.component';
import { MiddlewareService } from './middleware.service';
import { Workflow } from '../services/workflow.service';

@Component({
  selector: 'middleware-reentry',
  template: '<div></div>',
  standalone: false,
})
export class MiddlewareReentryComponent implements OnInit {
  connector: any;
  region: any;
  access: any;
  refresh: any;

  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private middlewareService: MiddlewareService,
    private userService: UserService,
    private router: Router,
  ) {}

  // This is the entry page that middleware will redirect back to, so we need to grab all the important data from the query string
  ngOnInit() {
    this.connector = this.route.snapshot.paramMap.get('connector');
    this.region = this.route.snapshot.paramMap.get('region') || '';
    this.access = this.route.snapshot.queryParams['Access'];
    this.refresh = this.route.snapshot.queryParams['Refresh'];

    if (this.userService.platform === Platform.MFD) {
      this.openBrowse();
    } else {
      // Post message to parent window and close
      const data = {
        connectorProvider: 'middleware',
        connector: this.connector,
        region: this.region,
        access: this.access,
        refresh: this.refresh,
      };
      if (window.opener) {
        window.opener.postMessage(data, window.location.origin);
        window.close();
      }
      else if (this.connector == 'Dropbox') {
        let message = {data: data};
        localStorage.setItem('mwData', JSON.stringify(message));
        window.close();
      }
    }
  }

  openBrowse() {
    this.middlewareService.region = this.region;
    this.middlewareService.connector = this.connector;
    this.middlewareService.connectorToken = this.access;
    this.middlewareService.connectorRefreshToken = this.refresh;

    const cloudState = JSON.parse(sessionStorage.getItem('cloudState') || '{}');
    const cloudStateWf: unknown = cloudState.wf;
    if ((cloudStateWf as Workflow).id !== undefined) {
      const wf = cloudStateWf as Workflow;
      if (wf.output.cloudRepoOptions) {
        wf.output.cloudRepoOptions.access = this.access;
        wf.output.cloudRepoOptions.refresh = this.refresh;
        sessionStorage.setItem('cwf', JSON.stringify(wf));
        this.userService.setUser(JSON.stringify(cloudState.user));
        this.router.navigate(['workflows-mfd'], {
          relativeTo: this.route.parent,
        });
      } else {
        const modalRef = this.modalService.open(MiddlewareBrowseComponent, {
          windowClass: 'xrx-popup modal-max',
        });
        modalRef.result
          .then((repoOptions) => {
            wf.output.cloudRepoOptions = repoOptions;
            sessionStorage.setItem('cwf', JSON.stringify(wf));
            this.userService.setUser(JSON.stringify(cloudState.user));
            this.router.navigate(['workflows-mfd'], {
              relativeTo: this.route.parent,
            });
          })
          .catch(() => {
            sessionStorage.setItem('cwf', JSON.stringify(wf));
            this.userService.setUser(JSON.stringify(cloudState.user));
            sessionStorage.removeItem('cloudState');
            this.router.navigate(['workflows-mfd'], {
              relativeTo: this.route.parent,
            });
          });
      }
    }
  }
}
